[
  {
    "code": "TG-C",
    "name": "Centre"
  },
  {
    "code": "TG-K",
    "name": "Kara"
  },
  {
    "code": "TG-M",
    "name": "Maritime (Région)"
  },
  {
    "code": "TG-P",
    "name": "Plateaux"
  },
  {
    "code": "TG-S",
    "name": "Savannes"
  }
]